import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { ServicesComponent } from './component/services/services.component';
import { GlobalService } from './helper/global.service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductsComponent } from './component/products/products.component';
import { VideoComponent } from './component/video/video.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClientTestimonialComponent } from './component/client-testimonial/client-testimonial.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ServicesComponent,
    ProductsComponent,
    VideoComponent,
    ClientTestimonialComponent,
    AboutUsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    NgbModule,
    ReactiveFormsModule
  ],
  providers: [
    GlobalService,
    ProductsComponent,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
